import Vue from "vue";
import Vuex from "vuex";
import storeModuleApp from "./modules/app.js";
import storeModuleAuth from "./modules/auth.js";
import storeModuleNotification from "./modules/notification.js";
import fm from "@/fm/store.js";

Vue.use(Vuex);

const { VUE_APP_VERSION } = process.env;

const storeInstance = new Vuex.Store({
  state: {
    appInfo: {
      version: VUE_APP_VERSION
    }
  },
  getters: {
    getVersion(state) {
      return state.appInfo.version;
    }
  },
  modules: {
    storeModuleApp,
    storeModuleAuth,
    storeModuleNotification,
    fm
  }
});

export default storeInstance;
